import { render, staticRenderFns } from "./DevNavigator.vue?vue&type=template&id=353ed182&scoped=true&"
import script from "./DevNavigator.vue?vue&type=script&lang=js&"
export * from "./DevNavigator.vue?vue&type=script&lang=js&"
import style0 from "./DevNavigator.vue?vue&type=style&index=0&id=353ed182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353ed182",
  null
  
)

export default component.exports